import styled from 'styled-components';
import { ellipsis } from '../../styles/ellipsis';

export const ContentInfoTitle = styled.div`
	margin-bottom: 10px;
	overflow: hidden;

	h1 {
		font-size: 45px;
		float: left;
		max-width: 80%;
		${ellipsis};
	}
`;
